import React, {Component} from 'react'
import './OnlineRetentionTouchPoint.css';

export default class OnlineRetentionTouchPoint extends Component {
    constructor(props){
        super(props);
        this.state = {
            onlineRetention:{
                tc:{
                    label:"網上續約優惠",
                    url:"https://www.three.com.hk/3Care/chi/MultiOfferOTPLogin.jsp?lang=chi&cid=Retention&cmpid=CAMP0006&intcmp=3comacct"
                },
                en:{
                    label:"Online Renewal Offer",
                    url:"https://www.three.com.hk/3Care/eng/MultiOfferOTPLogin.jsp?lang=eng&cid=Retention&cmpid=CAMP0006&intcmp=3comacct"
                }
            },
            cvm:{
                tc:{
                    label:"網上升級優惠",
                    url:"https://www.three.com.hk/3Care/chi/MultiOfferOTPLogin.jsp?lang=chi&cid=Retention&cmpid=CAMP0006&intcmp=3comacct"
                },
                en:{
                    label:"Online Upgrade Offer",
                    url:"https://www.three.com.hk/3Care/eng/MultiOfferOTPLogin.jsp?lang=eng&cid=Retention&cmpid=CAMP0006&intcmp=3comacct"
                }
            }
        }
    }

    render(){
        
        const loginProfile = this.props.loginProfile;
        if(loginProfile == null || (!loginProfile.isEnableTouchPointOnlineRetention && !loginProfile.isEnableTouchPointCVM)) return null;

        const type = loginProfile.isEnableTouchPointOnlineRetention ? "onlineRetention" : "cvm";
        const lang = window.THREE_REACT_APP_GLOBAL.language == "en" ? "en" : "tc"
        const touchPoint = this.state[type][lang];

        return (
            <a href={touchPoint.url} className="text-link" target="_blank">
                <div className="text">{touchPoint.label}</div>
                <svg className="svg" viewBox={"0 0 30 30"}>
                    <path d="M5 5 L15 15 L5 25  L15 15 Z" stroke-width="2" stroke="black"/>
                </svg>
            </a>
        )
    }
}